import { z } from "zod";

export function capitalizeFirstLetter(val: string): string {
	return String(val).charAt(0)?.toUpperCase() + String(val).slice(1);
}

export function formatPrice(amount: number, currencyCode: string) {
	return new Intl.NumberFormat("en-US", {
		style: "currency",
		currency: currencyCode,
	}).format(amount);
}

export function isEmptyString(val: string): boolean {
	return val === undefined || val === "" || typeof val !== "string";
}

export function isValidEmail(email: string): boolean {
	const emailSchema = z.string().email();
	return emailSchema.safeParse(email).success;
}
